import { render, staticRenderFns } from "./CustomIconView.vue?vue&type=template&id=2867f5e0&scoped=true"
import script from "./CustomIconView.vue?vue&type=script&lang=js"
export * from "./CustomIconView.vue?vue&type=script&lang=js"
import style0 from "./CustomIconView.vue?vue&type=style&index=0&id=2867f5e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2867f5e0",
  null
  
)

export default component.exports